import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';
import { ToolTipBox, HoverableElement } from 'components/ToolTip/styles';
import { BUTTON_PRIMARY } from 'components/TCButton/styles';
import { InputIconFieldHoverContainer } from 'components/InputIcon/styles'

export const InfoContainer = styled.div`
    display: flex;
    flex:1;
    flex-flow: column;
    heigth:100%;
    word-break: break-all;
`

export const ContainerTitle = styled.div`
    display:flex;
    margin: 0 0 ${SIZE.TWO}px 0;
    font-family: Rubik;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;    
    text-align: left;
    color: #525252;
    z-index: 0; 
`

export const InfoBodyContainer = styled.div`
    display:flex;
    flex-flow: column;
    flex: 0 0 auto;
    padding: ${SIZE.THREE}px 30px ${SIZE.TWO}px 30px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: -2px 4px 15px 0 rgba(0, 0, 0, 0.15);
    ${InputIconFieldHoverContainer} {
        &:hover {
            background-color: #ffffff;  
        }
    }
`


export const ToolTipContainer = styled.div`    
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding:${SIZE.TWO}px;
    min-width: ${SIZE.THIRTY}px;
    

    ${BUTTON_PRIMARY}{
        width: ${SIZE.SEVENTEEN}px;
        height: ${SIZE.FIVE}px;
        flex-grow: 0;        
        padding: 10px;
        background-color: #122442;
        border: solid 1px #122442;
        border-radius: 3px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
    }
   
`

export const ToolTipText = styled.div`    
    display: flex;
    margin-bottom: ${SIZE.FOUR}px;
    flex-flow: column;
    align-items: center;
    justify-content: center;    
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
    word-wrap: normal;
    white-space: pre-wrap;
`

export const HoursContainer = styled.div`    
    display: flex;
    flex-flow: column;    
`

export const HourContainer = styled.div`    
    display: flex;
    flex-flow: row;    
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    margin-bottom:12px;
`
export const DayContainer = styled.div`    
    width:120px;

`
export const Day2Container = styled.div`        
`


export const IconContainer = styled.div`    
    display: flex;     
    justify-content: center;
    width:35px;
    
    
`